<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 16:25:54
 * @LastEditors: lzq
 * @LastEditTime: 2024-04-01 17:09:12
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\outboundManage\components\addOrder.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-drawer v-loading.fullscreen="loading" :visible="visible" size="60%" :destroy-on-close="true"
    :wrapper-closable="false" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <div slot="title" style="display: flex;justify-content: space-between;">
      <div> {{ orderInfo.orderId ? '编辑出库单' : '创建出库单' }}</div>
      <div>
        <el-button type="primary" @click="submit"> 保存 </el-button>
        <el-button @click="$emit('close')"> 返回 </el-button>
      </div>
    </div>
    <el-card class="udi-form group-box no-border" shadow="never">
      <el-form ref="form" :rules="rules" :model="form" label-width="160px">
        <div class="box-title">单据信息</div>
        <el-form-item label="发货日期" prop="specifyDeliveryDate">
          <el-date-picker v-model="form.specifyDeliveryDate" style="width: 250px;" value-format="yyyy-MM-dd" type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="单据编号" prop="bizId">
          <el-input v-model="form.bizId" maxlength="50" placeholder="请输入单据编号"></el-input>
        </el-form-item>
        <el-form-item label="业务类型" prop="bizType">
          <el-select v-model="form.bizType" placeholder="请选择">
            <el-option v-for="dict in dictObj.saleOrderType.filter(item => item.dictValue !== 'lswldd')"
              :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue">
            </el-option>
          </el-select>
          <el-form-item v-if="form.bizType === 'qtckyw'" label="" prop="qtType">
            <el-select v-model="form.qtType" placeholder="请选择">
              <el-option v-for="dict in dictObj.bizType" :key="dict.dictValue" :label="dict.dictLabel"
                :value="dict.dictValue">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form-item>

        <el-form-item label="申请部门" prop="applyOrgName">
          <el-select v-model="form.applyOrgName" v-maxlength="20" filterable remote reserve-keyword
            :remote-method="remoteMethodOrg" :loading="remoteLoading" placeholder="" allow-create clearable>
            <el-option v-for="item in applyList" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="3" maxlength="500" placeholder="请输入备注" show-word-limit style="width: 500px;"></el-input>
        </el-form-item>
        <template>
          <el-form-item  label="是否记录地址" prop="recordAddress">
          <el-radio-group v-model="form.recordAddress" @input="recordedAddressChange">
            <el-radio label="Y">是</el-radio>
            <el-radio label="N">否</el-radio>
          </el-radio-group>
        </el-form-item>
          <el-form-item label="客户名称" prop="recipientInfo.customerId">
            <div style="display: flex;align-items: center;">
              <el-select v-model="form.recipientInfo.customerId" v-maxlength="50" filterable placeholder="请选择客户名称"
                clearable @change="handleCustomerChange">
                <el-option v-for="item in customerListData" :key="item.id" :label="item.customer" :value="item.id">
                </el-option>
              </el-select>
              <el-form-item style="margin: 0 8px !important;" label="" prop="recipientInfo.recipientId">
                <el-select v-model="form.recipientInfo.recipientId" placeholder="选择收件人" filterable @change="handleRecipientChange">
                  <el-option v-for="recipient in customerRecipientVoList" :key="recipient.id" :label="recipient.name"
                    :value="recipient.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-button type="text" @click="handleAddRecipient">添加收件人</el-button>
            </div>

          </el-form-item>
          <el-form-item :class="{ 'is-required': form.recordAddress === 'Y' }" label="收件人区域" prop="recipientInfo.area">
            <el-cascader v-model="form.recipientInfo.area" :props="{ checkStrictly: true, value: 'label' }" disabled
              :options="regionData" />
          </el-form-item>
          <el-form-item label="收件人详细地址" prop="recipientInfo.customerAddress">
            <el-input v-model="form.recipientInfo.customerAddress" maxlength="200" disabled
              placeholder="请输入收件人详细地址"></el-input>
          </el-form-item>
          <el-form-item :class="{ 'is-required': form.recordAddress === 'Y' }"  label="收件人电话" prop="recipientInfo.customerTelephone">
            <el-input v-model="form.recipientInfo.customerTelephone" disabled placeholder="请输入收件人电话"></el-input>
          </el-form-item>
        </template>

        <div class="box-title">出库物料</div>
        <el-button style="margin-bottom: 12px;" type="primary" @click="selectDialog = true">添加物料</el-button>
        <el-table ref="dataTable" class="row-class" align="center" :data="form.goodsInstList">
          <el-table-column show-overflow-tooltip prop="goodsName" label="物料名称" />
          <el-table-column show-overflow-tooltip prop="specification" label="物料规格型号" />
          <el-table-column show-overflow-tooltip prop="diCode" label="产品DI" />
          <el-table-column show-overflow-tooltip prop="goodsCode" label="物料编码" />
          <el-table-column show-overflow-tooltip prop="batchNumber" label="批号">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="warehouseName" label="出库仓库" />
          <el-table-column prop="packageNumber" label="出库数量" width="120">
            <template slot-scope="{row, $index }">
              <el-form-item :rules="rules.packageNumber" label="" :prop="`goodsInstList[${$index}].packageNumber`">
                <el-input v-model.number="row.packageNumber" label="请输入出库数量"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="number" label="库存数量" />
          <el-table-column show-overflow-tooltip prop="packLevel" label="包装层级" />
          <el-table-column show-overflow-tooltip label="操作">
            <template slot-scope="{ $index }">
              <el-button type="size" @click="remoteGoods($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </el-card>
    <receipt v-if="receiptVisible" :visible="receiptVisible" :customer-info="customerInfo"
      @close="handleCloseRecipient">
    </receipt>

    <productSelect v-if="selectDialog" :visible="selectDialog" @getData="getData" @update:loading="loading = $event"
      @close="selectDialog = false" />
  </el-drawer>
</template>

<script>
import { getOrderInfo, getWareHouseNumber } from '@/api/orderManage'

import debounce from 'lodash/debounce'
import { findNode } from '@/utils/ruoyi'
import { regionData } from 'element-china-area-data'
import { getDict } from '@/api/common'
import productSelect from './productSelect'
import { saveOrder, getLot, getOrg, updateOrder } from '@/api/orderManage'
import { getCustomList } from '@/api/system/custom'
import receipt from './receipt'
export default {
  name: 'AddOrder',
  components: { productSelect, receipt },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    orderInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    // 这里存放数据
    return {
      loading: false,
      remoteLoading: false,
      selectDialog: false,
      regionData,
      categoryData: [],
      dictObj: {
        bizType: [],
        saleOrderType: []
      },
      receiptVisible: false,
      applyList: [],
      form: {
        recordAddress: 'Y',
        specifyDeliveryDate: null,
        bizId: null,
        bizType: null,
        qtType: null,
        applyOrgName: null,
        remark: null,
        recipientInfo: {
          customerId: null,
          recipientId: null,
          customerAddress: null,
          customerTelephone: null,
          customer: null,
        },
        goodsInstList: []
      },
      customerListData: [],
      customerInfo: {},
      receiveList: [],
      rules: {
        specifyDeliveryDate: [
          {
            required: true,
            message: '请选择发货日期',
            trigger: ['change', 'blur']
          }
        ],
        bizId: [
          {
            required: true,
            message: '请输入单据编号',
            trigger: ['change', 'blur']
          },
          {
            pattern: /^[a-zA-Z0-9\-_!@#$%^&*()+]+$/,
            message: '仅能输入数字、字符、大小写字母',
          }
        ],
        'recipientInfo.recipientId': [],
        recordAddress: [
          {
            required: true,
            message: '请选择是否记录地址',
            trigger: ['change', 'blur']
          }
        ],
        bizType: [
          {
            required: true,
            message: '请选择业务类型',
            trigger: ['change', 'blur']
          }

        ],
        applyOrgName: [
          {
            required: true,
            message: '请输入申请部门',
            trigger: ['change', 'blur']
          }
        ],
        'recipientInfo.customerId': [],
        batchNumber: [
          {
            required: true,
            message: '批号不能为空',
            trigger: ['change', 'blur']
          }
        ],
        packageNumber: [
          {
            required: true,
            message: '请输入出库数量',
            trigger: ['change', 'blur']
          },
          {
            pattern: /^[0-9]\d*$/,
            message: '请输入整数',
            trigger: ['change', 'blur']
          },
        ],
      }
    }
  },
  computed: {
    customerRecipientVoList() {
      const find = this.customerListData.find(item => item.id === this.form.recipientInfo.customerId)
      return find ? find.customerRecipientVoList : []
    }
  },
  created() {
    this.getDicts(['bizType', 'saleOrderType'])
    if (this.orderInfo.orderId) {
      this.getOrderInfo(this.orderInfo)
    } else {
      // 初始化添加收件人等规则
      this.recordedAddressChange('Y')
    }
    this.getCustomer()
  },
  // 方法集合
  methods: {
    // 处理是否记录地址变更
    recordedAddressChange(value) {
      if (value === 'Y') {
        this.rules['recipientInfo.recipientId'] = [{
          required: true,
          message: '请选择收件人',
          trigger: ['change', 'blur']
        }]
        this.rules['recipientInfo.customerId'] = [{
          required: true,
          message: '请选择客户名称',
          trigger: ['change', 'blur']
        }]
      } else {
        this.rules['recipientInfo.customerId'] = []
        this.rules['recipientInfo.recipientId'] = []
        this.$refs.form.clearValidate(['recipientInfo.customerId', 'recipientInfo.recipientId'])
      }
    },
    // 处理添加收件人
    handleAddRecipient() {
      if (!this.form.recipientInfo.customerId) return this.$message.error('请先选择客户')
      this.receiptVisible = true
      this.customerInfo = this.customerListData.find(item => item.id === this.form.recipientInfo.customerId)
    },
    handleCloseRecipient() {
      this.receiptVisible = false
      this.getCustomer()
    },
    // 处理收件人变更
    handleRecipientChange(value) {
      const recipientInfo = this.customerRecipientVoList.find(item => item.id === value)
      if (value) {
        this.form.recipientInfo.customerAddress = recipientInfo.address
        this.form.recipientInfo.customerTelephone = recipientInfo.telephone
        const area = [recipientInfo.provinceName, recipientInfo.cityName, recipientInfo.countyName]
        // 转换省市区
        this.$set(this.form.recipientInfo, 'area', area)
      } else {
        this.form.recipientInfo.customerAddress = null
        this.form.recipientInfo.customerTelephone = null
        this.form.recipientInfo.area = null
        this.$nextTick(() => {
          this.$refs.form.clearValidate(['recipientInfo.customerAddress', 'recipientInfo.customerTelephone', 'recipientInfo.area'])
        })
      }
    },
    // 获取单据信息
    getOrderInfo({ orderId }) {
      this.orderId = orderId
      // 获取基础信息数据
      this.loading = true
      getOrderInfo(orderId).then(res => {
        const {
          recipientInfoVo, goodsVoList
        } = res.data
        const area = [recipientInfoVo.consigneeProvinceName, recipientInfoVo.consigneeCityName, recipientInfoVo.consigneeCountyName]
        // 转换省市区
        this.$set(this.form.recipientInfo, 'area', area)
        for (const key in this.form.recipientInfo) {
          if (recipientInfoVo[key]) {
            this.form.recipientInfo[key] = recipientInfoVo[key]
          }
        }
        // 转换数据
        for (const key in this.form) {
          if (res.data[key]) {
            this.form[key] = res.data[key]
          }
        }
        this.form.goodsInstList = goodsVoList.map((item) => {
          return {
            ...item,
            isEdit: true
          }
        })
        this.form.goodsInstList.forEach((item, index) => {
          this.getWareHouseNumber(item, index)

        })
        // 处理客户名称是否必填
        this.recordedAddressChange(this.form.recordAddress)
      }).finally(() => {
        this.loading = false
      })
    },
    // 获取库存数量
    getWareHouseNumber({ batchNumber, warehouseId, goodsCode: materialCode }, index) {
      getWareHouseNumber({ batchNumber, warehouseId, materialCode }).then((res) => {
        const { number } = res.data
        this.$set(this.form.goodsInstList[index], 'number', number)
        this.form.goodsInstList[index].number = number
      })
    },
    // 处理客户名称变化,重置收件人信息
    handleCustomerChange() {
      this.form.recipientInfo.area = null
      this.form.recipientInfo.recipientId = null
      this.form.recipientInfo.customerTelephone = null
      this.form.recipientInfo.Address = null
      if (this.form.recipientInfo.customerId) {
        this.form.recipientInfo.customer = this.customerListData.find(item => item.id === this.form.recipientInfo.customerId).customer
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate(['recipientInfo.customerAddress', 'recipientInfo.customerTelephone', 'recipientInfo.area', 'recipientInfo.recipientId'])
      })
    },
    // 获取字典
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
        })
      })
    },
    getCustomer() {
      // 获取已有客户名称
      getCustomList({ pageSize: 9999, pageNum: 1 }).then((res) => {
        this.customerListData = res.rows
        this.remoteLoading = false
      })
        .catch(() => {
          this.remoteLoading = false
          this.customerListData = []
        })
    },
    remoteMethodOrg: debounce(
      function (name) {
        if (name !== '') {
          this.remoteLoading = true
          // 获取已有客户名称
          getOrg({ name }).then((res) => {
            this.applyList = res.data

            this.remoteLoading = false
          })
            .catch(() => {
              this.remoteLoading = false
              this.applyList = []
            })
        } else {
          this.applyList = []
        }
      },
      500,
      {
        leading: true, // 延长开始后调用
        trailing: false // 延长结束前调用
      }
    ),

    // 处理弹窗DI确认选择
    getData(data) {
      const { diCode, warehouseId, warehouseName, specification, name, packingDiList, batchNumber, number, materialCode: goodsCode, packLevel, materialName: goodsName } = data

      if (this.form.goodsInstList.some((item) => item.diCode === diCode && item.batchNumber === batchNumber && item.goodsCode === goodsCode && item.warehouseId === warehouseId)) {
        this.$message.error('该仓库同批次物料已选择！')
      } else if (Number(number) <= 0) {
        this.$message.error('当前所选物料库存数量为0！')
      } else {
        this.form.goodsInstList.push({
          warehouseName,
          warehouseId,
          number,
          goodsName, diCode, packLevel, specification, name, packingDiList, goodsCode, batchNumber, packageNumber: null, edit: true
        })
        this.selectDialog = false
      }
    },
    // 处理删除
    remoteGoods(index) {
      this.form.goodsInstList.splice(index, 1)
    },
    // 根据选择得物料查询对应物料得批号
    getLot(diCode, index) {
      getLot({ diCode }).then((res) => {
        this.$set(this.form.goodsInstList[index], 'lotList', res.data)
        console.log(res.data);
      })
    },
    // 保存
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        if (this.form.goodsInstList.length === 0) {
          this.$message.error('出库物料不能为空')
          return
        }
        const params = JSON.parse(JSON.stringify(this.form));
        if (params.recipientInfo.area) {
          // 省市区转换
          const [consigneeProvinceName, consigneeCityName, consigneeCountyName] = params.recipientInfo.area
          params.recipientInfo.consigneeProvinceName = consigneeProvinceName
          params.recipientInfo.consigneeCityName = consigneeCityName
          params.recipientInfo.consigneeCountyName = consigneeCountyName
          delete params.recipientInfo.area
        }
        if(params.recipientInfo.recipientId){
          params.recipientInfo.customerName = this.customerRecipientVoList.find(item => item.id === params.recipientInfo.recipientId).name
        }else{
          params.recipientInfo.customerName = ''
          params.recipientInfo.consigneeProvinceName =  ''
          params.recipientInfo.consigneeCityName = ''
          params.recipientInfo.consigneeCountyName = ''
          params.recipientInfo.customerTelephone = ''
          params.recipientInfo.customerAddress = ''
          params.recipientInfo.customer = ''
        }
        this.loading = true
        if (!this.orderInfo.orderId) {
          saveOrder(params).then(() => {
            this.$emit('close')
          }).finally(() => {
            this.loading = false
          })
        } else {
          updateOrder({ ...params, orderId: this.orderInfo.orderId }).then(() => {
            this.$emit('close')
          }).finally(() => {
            this.loading = false
          })
        }

      })
    }
  }
}
</script>
<style scoped>
.grid-box>>>.el-form-item .el-form-item__label {
  line-height: 2.5 !important;
}

.row-class>>>.el-form-item {
  margin: 0 !important;
}
</style>
